

import { BaseEntity, CommonSettingEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseDocument } from './../entities/basedocument.entity';
export class BaseTransDocument extends BaseDocument
{   
    public RefDate: Date; 
    public DueDate: Date; 
    public OpenSum: number; 
    public IsOpen: boolean; 
    public Comments: string; 
    public IsPaymentAllowed: boolean; 
    public AdditionalNotes: string; 
	
}



